// Web-side зеркало permissions из @ozr/shared. Дублирую чтобы не тянуть весь пакет.
// Должно совпадать с packages/shared/src/permissions.ts

export type Role = 'admin' | 'manager' | 'warehouse' | 'viewer';

export const ROLE_LABELS: Record<Role, string> = {
  admin: 'Администратор',
  manager: 'Менеджер маркетплейсов',
  warehouse: 'Сотрудник склада',
  viewer: 'Просмотр',
};

const SECTION_ACCESS: Record<string, Role[]> = {
  dashboard:        ['admin', 'manager', 'warehouse', 'viewer'],
  finance:          ['admin', 'manager', 'viewer'],
  products:         ['admin', 'manager', 'viewer'],
  shipments:        ['admin', 'manager', 'warehouse', 'viewer'],
  returns:          ['admin', 'manager', 'warehouse', 'viewer'],
  actions:          ['admin', 'manager', 'viewer'],
  repricers:        ['admin', 'manager'],
  strategies:       ['admin', 'manager'],
  ozon_strategies:  ['admin', 'manager'],
  reviews:          ['admin', 'manager'],
  sync:             ['admin', 'manager'],
  settings:         ['admin'],
};

export type Action =
  | 'product.update'
  | 'product.set_price'
  | 'product.bulk_rrp'
  | 'strategy.create'
  | 'strategy.run'
  | 'rrp.run'
  | 'sync.trigger'
  | 'shipment.ship'
  | 'shipment.create_act'
  | 'review.reply'
  | 'review.generate_ai'
  | 'user.manage'
  | 'settings.update'
  | 'schedule.update';

const ACTION_ROLES: Record<Action, Role[]> = {
  'product.update':       ['admin', 'manager'],
  'product.set_price':    ['admin', 'manager'],
  'product.bulk_rrp':     ['admin', 'manager'],
  'strategy.create':      ['admin', 'manager'],
  'strategy.run':         ['admin', 'manager'],
  'rrp.run':              ['admin', 'manager'],
  'sync.trigger':         ['admin', 'manager'],
  'shipment.ship':        ['admin', 'manager', 'warehouse'],
  'shipment.create_act':  ['admin', 'manager', 'warehouse'],
  'review.reply':         ['admin', 'manager'],
  'review.generate_ai':   ['admin', 'manager'],
  'user.manage':          ['admin'],
  'settings.update':      ['admin'],
  'schedule.update':      ['admin'],
};

export function canAccessSection(role: Role | null | undefined, section: string): boolean {
  if (!role) return false;
  return SECTION_ACCESS[section]?.includes(role) ?? false;
}

export function canDoAction(role: Role | null | undefined, action: Action): boolean {
  if (!role) return false;
  return ACTION_ROLES[action]?.includes(role) ?? false;
}

export function homeRoute(role: Role | null | undefined): string {
  if (role === 'warehouse') return '/shipments';
  return '/dashboard';
}
